import { Component, OnInit, Input, ViewChildren, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlickCarouselComponent, SlickCarouselModule } from 'ngx-slick-carousel';

declare var $:any;


@Component({
  standalone: true,
  selector: 'app-slick-carousel',
  imports: [CommonModule, SlickCarouselModule],
  templateUrl: './slick-carousel.component.html',
  styleUrls: ['./slick-carousel.component.scss'],
})
export class AppSlickCarouselComponent implements OnInit {
  @Input() data = [];
  @Input() innerContent;
  @Input() config;
  @Input() class="carousel";
  constructor() {}
  @ViewChild("slickModal") slickModal: SlickCarouselComponent;

  ngOnInit(): void {
    
  }

  unslickCarousel(): void {
    try {
      if(this.slickModal){
        this.slickModal.unslick();
      } 
    } catch (error) {
      console.log('error',error)
    }
  }

  slickCarousel(): void {
    try{
      if(this.slickModal){
        this?.slickModal?.initSlick();
      }
    } catch (error) {
      console.log('error',error)
    }
  }
}
